import toastError from '../../toasts/toastError';

import { Button, Dialog, DialogActions } from '@mui/material';

import html2pdf from 'html2pdf.js';

export default function TicketMessagesDialog({ open, handleClose, ticketId }) {
  const handleExportToPDF = () => {
    const messagesListElement = document.getElementById('messagesList');
    const headerElement = document.getElementById('TicketHeader');

    const pdfOPtions = {
      margin: 1,
      filename: `relatório_atendimento_${ticketId}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    if (messagesListElement) {
      const headerClone = headerElement.cloneNode(true);
      const messagesListClone = messagesListElement.cloneNode(true);

      const containerElement = document.createElement('div');
      containerElement.appendChild(headerClone);
      containerElement.appendChild(messagesListClone);
      html2pdf().from(containerElement).set(pdfOPtions).save();

      handleClose();
    } else {
      toastError('Elemento não encontrado para exportar.');
    }
  };

  return (
    <Dialog maxWidth='md' onClose={handleClose} open={open}>
      <DialogActions>
        <Button onClick={handleExportToPDF} color='primary'>
          Exportar para PDF
        </Button>
        <Button onClick={handleClose} color='primary'>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
